export default function (state, val) {
    for(let k in val){
        state.system[k] = val[k];
    }
}